import { Directive, TemplateRef } from "@angular/core";

@Directive({ selector: "[radrQueryEmptyWarning]" })
export class QueryEmptyWarningDirective {
  constructor(public template: TemplateRef<any>) {}
}
